import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/users`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function usersList() {
  return axios.get(`${url}/user-data`)
      .then(response => {
        return {
          usersList: response.data,
          meta: response.data.meta
        };
      });
}

function retouchersList(role) {
  let neadleUrl = `${url}/new_order/getWorkers/`;
  switch (role) {
    case 'junior-retoucher':
      neadleUrl += 'junior-retoucher';
      break;
    case 'pro-retoucher':
      neadleUrl += 'pro-retoucher';
      break;
    case 'test-retoucher':
      neadleUrl += 'test-retoucher';
      break;
    case 'junior-and-retoucher':
      neadleUrl += 'junior-and-retoucher';
      break;
    default:
      neadleUrl += 'retoucher';
  }
  return axios.get(neadleUrl)
    .then(response => {
      return {
        retouchersList: response.data,
        meta: response.data.meta
      };
    });
}

function chosenRolesUsersList(payload) {
  const options = {
    headers: {
      'Content-Type': 'application/json',
    }
  };
  return axios.post(`${url}/new_order/getUsersOfRoles`, payload, options)
    .then(response => {
      return {
        chosenRolesUsersList: response.data
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/users/${id}`, options)
    .then(response => {
      let user = jsona.deserialize(response.data);
      delete user.links;
      return user;
    });
}

function add(user) {
  const payload = jsona.serialize({
    stuff: user,
    includeNames: null
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/users`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(user) {
  const payload = jsona.serialize({
    stuff: user,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/users/${user.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function updateUser(user) {
  const payload = user;
  const options = {
    headers: {
      'Content-Type': 'application/json',
    }
  };
  return axios.post(`${url}/user-update`, payload, options)
    .then(response => {
      return {
        updateUser: response.data
      };
    });
}

function delUser(user) {
  const payload = user;
  const options = {
    headers: {
      'Content-Type': 'application/json',
    }
  };
  return axios.post(`${url}/user-del`, payload, options)
      .then(response => {
        return {
          updateUser: response.data
        };
      });
}

function restoreUser(user) {
  const payload = user;
  const options = {
    headers: {
      'Content-Type': 'application/json',
    }
  };
  return axios.post(`${url}/user-restore`, payload, options)
      .then(response => {
        return {
          restoreUser: response.data
        };
      });
}

function createUser(user) {
  const payload = user;
  const options = {
    headers: {
      'Content-Type': 'application/json',
    }
  };
  return axios.post(`${url}/user-create`, payload, options)
    .then(response => {
      return {
        createUser: response.data
      };
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/users/${id}`, options);
}

function upload(user, image) {
  const bodyFormData = new FormData();
  bodyFormData.append('attachment', image);

  return axios.post(`${url}/uploads/users/${user.id}/profile-image`, bodyFormData)
      .then(response => {
        return response.data.url;
      });
}

function getWeekBonusData() {
  return axios.get(`${url}/users/week-bonus-data`)
      .then(response => {
        return response.data;
      });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  upload,
  usersList,
  updateUser,
  delUser,
  restoreUser,
  createUser,
  retouchersList,
  chosenRolesUsersList,
  getWeekBonusData
};

